<mat-toolbar color="primary">
  <span id="signering-otp-dialog-tittel">
    @switch (kanal) {
      @case (kanaler.sms) {
        {{ "Signer med engangskode sendt per SMS"|translate }}
      }
      @case (kanaler.epost) {
        {{ "Signer med engangskode sendt per e-post"|translate }}
      }
    }
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

@switch (modus()) {
  @case ('angiTelefonnummer') {
    <form [formGroup]="telefonnummerSkjema" (ngSubmit)="angiMobilnummerOgSendOtp()" data-testid="angi-mobilnummer-skjema">
      <mat-dialog-content>
        <div class="innhold">
          <p>{{ 'Oppgi ditt mobiltelefonnummer, inklusive landkode'|translate }}</p>
          <mat-form-field>
            <mat-label>{{ 'Mobiltelefonnummer'|translate }}</mat-label>
            <mobilnummer-felt [formControl]="telefonnummerSkjema.controls.telefonnummer"/>
          </mat-form-field>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
        <button mat-raised-button color="primary" type="submit" cdkFocusInitial
                [disabled]="telefonnummerSkjema.invalid || arbeider()" [visSpinner]="arbeider()"
                spinnerTekst="{{'Registrerer...'|translate}}" data-testid="send">
          {{ 'Registrer'|translate }}
        </button>
      </mat-dialog-actions>
    </form>
  }
  @case ('otpIkkeSendt') {
    <mat-dialog-content>
      <div class="innhold">
        <p>{{ 'Engangskode kunne ikke sendes'|translate }}</p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    </mat-dialog-actions>
  }
  @case ('oppgikode') {
    <form [formGroup]="otpSkjema" (ngSubmit)="signer()">
      <mat-dialog-content>
        <div class="innhold">
          <p>{{ 'Skriv inn koden vi har sendt til {epost}.'|translate: {epost: otpSendtRespons()?.otpSendtTil ?? '...'} }}</p>
          <otp-felt [formControl]="otpSkjema.controls.otp" [ugyldig]="otpValideringFeilet()"/>
          @if (otpVarighet() != null) {
            <p class="varighet">
              @if (tidTilOtpUtloeptIMinutter() <= 0) {
                {{ 'Koden har utløpt på tid'|translate }},
                <a (click)="sendOtp()">{{ 'send ny kode'|translate }}</a>
              } @else {
                <!-- trekker fra 5 for at sirkelen ikke skal være sluttet fra starten -->
                <mat-progress-spinner [value]="((tidTilOtpUtloept()!.total('seconds')/otpVarighet()!.total('seconds'))*100)-5" mode="determinate" diameter="20"/>
                {{ 'Koden er gyldig i {antall} minutter til'|translate:{antall: tidTilOtpUtloeptIMinutter()} }}
              }
            </p>
          }
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
        <button mat-raised-button color="primary" type="submit" cdkFocusInitial
                [disabled]="otpSkjema.invalid || arbeider()" [visSpinner]="arbeider()"
                spinnerTekst="{{'Signerer...'|translate}}" data-testid="bekreft">
          {{ 'Bekreft'|translate }}
        </button>
        <!-- pakket i span da matTooltip ikke vises på disablet button -->
        <span [matTooltip]="sendNyOtpTillat() ? ('Få tilsendt ny otp-kode'|translate) : ('Du må vente minst ett minutt før ny otp-kode kan sendes'|translate) ">
          <button mat-button color="primary" type="button"
                  (click)="sendOtp()"
                  [disabled]="senderOtp() || !sendNyOtpTillat()">
            {{ "Send ny kode"|translate }}
          </button>
        </span>

      </mat-dialog-actions>
    </form>
  }
}
